<template>
  <v-card style="height: 120%" class="rounded-lg">
    <v-card-title
      style="
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 33px;
        font-weight: bold;
        color: #05523e;
        padding-top: 40px;
      "
    >
      Edit Shortage List
    </v-card-title>
    <v-icon
      class="close"
      size="35"
      @click="$store.commit('common/changeEditShortageModalView')"
      >mdi-window-close</v-icon
    >

    <!-- search -->
    <div
      style="
        margin: 1.5% 3.5% auto;
        justify-content: center;
        align-items: center;
      "
    >
      <!-- search by word -->
      <div style="display: flex; height: 40px; align-items: self-end">
        <div style="font-size: 23px; font-weight: bold; width: 150px">
          Category
        </div>
        <v-select
          v-model="categoryColumn"
          label="All"
          :items="categories"
          item-text="name"
          item-value="value"
          style="max-width: 160px; min-width: 100px; height: 46px"
          single-line
          color="#05523E"
        />
        <v-text-field
          v-model="search"
          style="
            margin: -20px 10px -20px 20px;
            max-width: 150px;
            min-width: 100px;
          "
          placeholder="Search"
          clearable
          v-on:keyup.enter="searchByWord"
        />
        <v-btn
          class="white--text elevation-5 rounded-lg"
          color="#05523E"
          style="max-width: 130px; min-width: 110px; height: 32px"
          @click="searchByWord"
          >Search</v-btn
        >
      </div>
      <!-- search by department -->
      <div style="display: flex">
        <div
          style="
            font-size: 23px;
            font-weight: bold;
            width: 150px;
            line-height: 65px;
          "
        >
          Department
        </div>
        <v-select
          v-model="departmentColumn"
          label="All"
          @input="searchByDepartment"
          :items="$store.state.invoice.departments"
          item-text="name"
          item-value="value"
          style="max-width: 160px; min-width: 100px"
          single-line
          color="#05523E"
        />
      </div>
    </div>
    <div style="margin: 0.5% 3.5% auto; padding-bottom: 20px">
      <v-data-table
        :headers="headers"
        :items="$store.state.invoice.inventoryList"
        :page.sync="page_No"
        :items-per-page="10"
        hide-default-footer
        class="elevation-3"
        :loading="loading"
      >
        <!-- <template v-slot:header="{ props: { headers } }">
                <thead>
                    <tr>
                        <th v-for="h in headers" v-bind:key="h.text">
                            <span style="color: black; font-weight: bold; font-size: 17px;">{{h.text}}</span>
                        </th>
                    </tr>
                </thead>
                </template> -->
        <template v-slot:item="{ item }">
          <tr>
            <td>{{ item.itemNum }}</td>
            <td>{{ item.itemName }}</td>
            <td>{{ item.vendorName }}</td>
            <td>{{ item.department }}</td>
            <td>
              <v-btn
                v-if="item.inShortage"
                class="elevation-0 pa-0 ma-0"
                style="width: 10px; margin: 0; backgroundcolor: transparent"
                @click="removeShortage(item.itemNum)"
              >
                <v-icon size="32" color="#D86C6C">mdi-minus-circle</v-icon>
              </v-btn>
              <v-btn
                v-else
                class="elevation-0 pa-0 ma-0"
                style="width: 10px; margin: 0; backgroundcolor: transparent"
                @click="addShortage(item.itemNum)"
              >
                <v-icon size="32" color="#05523E">mdi-plus-circle</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
      <div class="text-center pt-2">
        <v-pagination
          style="padding-top: 8px"
          color="#05523E"
          v-model="page_No"
          :length="$store.state.invoice.inventoryPages"
          :total-visible="10"
          @input="movePage"
        />
      </div>
    </div>
  </v-card>
</template>

<script>
import { runGqlQuery } from "@/graphql/gqlUtil.js";
import { GETINVENTORYLENGTH } from "@/graphql/InvoiceQueries.js";

export default {
  async created() {
    this.loading = true;
    await this.searchInventories();
    this.loading = false;
  },
  data() {
    return {
      departmentColumn: "",
      selectedDepartment: [],
      categoryColumn: "",
      search: "",
      page_No: 1,
      headers: [
        {
          text: "Item Number",
          align: "start",
          sortable: true,
          value: "itemNum",
          sort: (a, b) => a.localeCompare(b),
        },
        {
          text: "Item Name",
          value: "itemName",
          sort: (a, b) => a.localeCompare(b),
        },
        {
          text: "Vendor Name",
          value: "vendorName",
          //   sort: (a, b) => a.localeCompare(b),
        },
        {
          text: "Department",
          value: "department",
          sort: (a, b) => a.localeCompare(b),
        },
        { text: "", value: "inTemplate", sort: (a, b) => a.localeCompare(b) },
      ],
      categories: [
        { name: "Category", value: "", sort: (a, b) => a.localeCompare(b) },
        {
          name: "Item Number",
          value: "ItemNum",
          sort: (a, b) => a.localeCompare(b),
        },
        {
          name: "Item Name",
          value: "ItemName",
          sort: (a, b) => a.localeCompare(b),
        },
        {
          name: "Vendor Name",
          value: "Company",
          sort: (a, b) => a.localeCompare(b),
        },
      ],
      custNum: this.custNumber,
      loading: false,
    };
  },
  methods: {
    async getInventoriesLength() {
      try {
        const req = {
          Column: this.categoryColumn,
          Search: this.search,
          Dept_ID: this.selectedDepartment,
        };

        const inventoryPage = await runGqlQuery(GETINVENTORYLENGTH, req);

        this.$store.state.invoice.inventoryPages = Math.ceil(
          inventoryPage.getInventoriesLength.Length / 10
        );
      } catch (err) {
        console.error(err);
      }
    },
    async getInventories() {
      try {
        this.loading = true;
        const req = {
          Column: this.categoryColumn,
          Search: this.search,
          Dept_ID: this.selectedDepartment,
          Page_No: this.page_No - 1,
          Page_Size: 10,
          belong: "Shortage",
        };
        await this.$store.dispatch("invoice/getInventoryList", req);
      } catch (err) {
        console.error(err);
      }
      this.loading = false;
    },
    async searchInventories() {
      try {
        this.loading = true;
        await this.getInventoriesLength();
        this.page_No = 1;
        await this.getInventories();
      } catch (err) {
        console.error(err);
      }
      this.loading = false;
    },
    async searchByWord() {
      try {
        this.loading = true;
        if (this.categoryColumn === "" && this.search === null) {
          await this.searchInventories();
        } else if (this.categoryColumn === "" && this.search !== "") {
          return this.$store.commit("common/snackErrOn", {
            text: "Please select a category.",
          });
        }
        this.searchInventories();
      } catch (err) {
        console.error(err);
      }
      this.loading = false;
    },
    async searchByDepartment() {
      try {
        this.loading = true;
        if (this.departmentColumn !== "") {
          this.selectedDepartment = [this.departmentColumn];
        } else {
          this.selectedDepartment = [];
        }

        this.searchInventories();
      } catch (err) {
        console.error(err);
      }
      this.loading = false;
    },
    async addShortage(itemNum) {
      try {
        await this.$store.dispatch("invoice/createShortageList", {
          ItemNum: itemNum,
        });
        await this.afterShortageFunc();
      } catch (err) {
        console.error(err);
      }
    },
    async getShortageList() {
      try {
        const req = { Page_No: 0, Page_Size: 10 };
        await this.$store.dispatch("invoice/getShortageList", req);
      } catch (err) {
        console.error(err);
      }
    },
    async removeShortage(itemNum) {
      try {
        await this.$store.dispatch("invoice/deleteShortage", {
          ItemNum: itemNum,
        });
        await this.afterShortageFunc();
      } catch (err) {
        console.error(err);
      }
    },
    async afterShortageFunc() {
      try {
        await this.$store.dispatch("invoice/getShortageListAll");
        await this.getInventories();

        await this.$emit("getShortageListLength");
        await this.$emit("getShortageList");
      } catch (err) {
        console.error(err);
      }
    },
    async movePage(page) {
      try {
        this.page_No = page;
        await this.getInventories();
      } catch (err) {
        console.error(err);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.close {
  position: absolute;
  right: 15px;
  top: 15px;
  color: black;
}
</style>
